<section class="provider-row" [class.divided]="divided" [class.coming-soon]="comingSoon">
  <div class="provider-header">
    <div class="provider-heading">
      <span class="provider-name">{{ name }}</span>
      <button type="button" *ngIf="selected !== null && !comingSoon" class="provider-dot" [class.on]="selected"
              [disabled]="selected || !selectable" [attr.aria-pressed]="selected"
              [title]="selected ? 'Primary' : selectable ? 'Set as primary' : 'Not available'"
              [attr.aria-label]="selected ? name + ' is primary' : 'Set ' + name + ' as primary'"
              (click)="select.emit()"></button>
      <span *ngIf="comingSoon" class="br-badge br-badge--neutral">Coming soon</span>
      <ng-content select="[provider-status]"></ng-content>
    </div>
    <div class="provider-actions"><ng-content select="[provider-actions]"></ng-content></div>
    <div class="provider-description">
      <span class="br-text-muted">{{ description }}</span>
      <ng-content select="[provider-links]"></ng-content>
    </div>
  </div>
  <ng-content></ng-content>
</section>
